'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.MySwiper = void 0;
const $ = require("jquery");
const swiper_1 = require("swiper");
const swiper_2 = require("swiper");
class MySwiper {
    constructor() {
        // スペシャルコンテンツのコピー切り替えフラグ
        this.isViewSpecial = false;
        // PICKUP
        const swiperPickup = new swiper_1.default('.bulletTopPickup', {
            modules: [swiper_2.Navigation, swiper_2.Autoplay],
            loop: true,
            speed: 500,
            navigation: {
                nextEl: ".trigPickupNext",
                prevEl: ".trigPickupPrev"
            },
            autoplay: {
                delay: 5000,
            },
            slidesPerView: 1.5,
            spaceBetween: 24,
            breakpoints: {
                // スライドの表示枚数：801px以上の場合
                801: {
                    slidesPerView: 2.5,
                    spaceBetween: 48,
                },
                1400: {
                    slidesPerView: 3.5,
                }
            }
        });
        // Special
        const swiperSpecial = new swiper_1.default('.bulletTopSpecial', {
            modules: [swiper_2.Navigation, swiper_2.Autoplay],
            loop: true,
            speed: 200,
            centeredSlides: true,
            navigation: {
                nextEl: ".trigOtonaNext",
                prevEl: ".trigOtonaPrev"
            },
            autoplay: {
                delay: 10000,
            },
            slidesPerView: "auto",
            breakpoints: {
                // スライドの表示枚数：801px以上の場合
                801: {
                    spaceBetween: 48,
                }
            },
            on: {
                slideChangeTransitionEnd: (e) => {
                    this.indexSpecial = e.realIndex + 1;
                    this.changeCopyText(this.isViewSpecial, this.indexSpecial);
                },
            }
        });
        // News
        const swiperNews = new swiper_1.default('.bulletTopNews', {
            modules: [swiper_2.Autoplay],
            loop: true,
            speed: 500,
            autoplay: {
                delay: 5000,
            },
            slidesPerView: 2,
            spaceBetween: 15,
            breakpoints: {
                // スライドの表示枚数：801px以上の場合
                801: {
                    slidesPerView: 4,
                    spaceBetween: 44,
                }
            }
        });
        $(window).on('load scroll', (e) => {
            const scroll = $(window).scrollTop();
            const position = $('.special-contents__wrap').offset().top;
            const browserHeight = $(window).outerHeight();
            if (scroll > position - (browserHeight / 2)) {
                this.isViewSpecial = true;
                this.changeCopyText(this.isViewSpecial, this.indexSpecial);
            }
        });
    }
    // Specialコンテンツのテキスト切り替え
    changeCopyText(isView, index) {
        if (isView === true) {
            $('.bulletTopCopy').children('p').attr('data-is-active', 'false');
            $(`.bulletTopCopy[data-number="${index}"]`).children('p').attr('data-is-active', 'true');
        }
    }
}
exports.MySwiper = MySwiper;
exports.default = MySwiper;
